var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataIsLoaded)?_c('div',{staticClass:"container__content"},[_c('div',{staticClass:"company__dashboard"},[_c('img',{attrs:{"src":this.company.logo,"alt":"company-logo"}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }